module.exports = "/next-static/_next/static/images/block_image_show_comments-48a720f7baa16f9e40b14242e631eed6.png";